import { Component } from 'react'
import PropTypes  from 'prop-types'
import Dialog from 'material-ui/Dialog'
import './delete-dialog.css'
import intl from 'react-intl-universal'
import Button from 'components/button'

class DeleteDialog extends Component {
  render() {
    const {
      title,
      open,
      handleClose,
      handleConfirm,
      warningMessage,
      errorDetail,
    } = this.props

    return (
      <Dialog
        title={title}
        contentStyle={{ width: '400px' }}
        open={open}
        onRequestClose={handleClose}
        actionsContainerClassName="container-action-buttons__deleteModal"
        actions={[
          <Button
            value={intl.get('master-data.general.materials.delete')}
            buttonType='danger'
            onClick={handleConfirm}
            className='container-action-buttons__deleteModal--buttons'
            key={1}
          />,
          <Button
            value={intl.get('master-data.general.materials.cancel')}
            data-testid="buttonCancel"
            buttonType='default'
            onClick={handleClose}
            className='container-action-buttons__deleteModal--buttons'
            key={2}
          />
        ]}>
        <div className='container-message'>
          {warningMessage}
        </div>

        {errorDetail && (
          <div className='container-error'>
            {errorDetail}
          </div>
        )}
      </Dialog>
    )
  }
}

DeleteDialog.propTypes = {
  title: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleConfirm: PropTypes.func.isRequired,
  warningMessage: PropTypes.string.isRequired,
  errorDetail: PropTypes.string,
}

export default DeleteDialog
